// extracted by mini-css-extract-plugin
module.exports = {"Scroll":"Scroll_Scroll__2EKYz","ScrollX":"Scroll_ScrollX__2pUc7","ScrollY":"Scroll_ScrollY__1QsuC"};